export default {
  title: 'Diagnostic Assessments',
  all_diagnostics: 'All assessments',
  filter_by_grade: 'Filter by grade',
  filter_by_country: 'Filter by country',
  select_country: 'Select a country',
  select_grade: 'Select a grade',
  all_grades: 'All grades',
  grade: 'Grade',
  level: 'Level',
  name: 'Name',
  has_variant: 'Has variant',
  no_variant: 'No variant',
  edit: 'Edit',
  back_to_list: 'Back to Diagnostics',
  questions: 'Questions',
  question: 'Question',
  question_number: 'Question #',
  skill: 'Skill',
  correct_answer: 'Correct answer',
  variant: 'Variant',
  actions: 'Actions',
  evaluation: 'Assessment',
  country: 'Country',
  edit_question: 'Edit Question',
  original_reference: 'Original (reference)',
  adapted_question: 'Adapted question',
  alternatives: 'Alternatives',
  alternative: 'Alternative',
  answer: 'Answer',
  correct: 'correct',
  cancel: 'Cancel',
  save_changes: 'Save changes',
  saving: 'Saving...',
  save_success: 'Variant saved successfully',
  save_error: 'Error saving variant',
  field_required: 'This field is required',
  no_permission: 'You do not have permission to access this feature',
  all_levels: 'All levels',
  all_variants: 'All',
  search_placeholder: 'Search by ID or name',
  search: 'Search',
  clear_filters: 'Clear filters',
  levels: {
    INITIAL: 'Diagnostic',
    INTERMEDIATE: 'Intermediate',
    ADVANCED: 'Closing',
  },
  countries: {
    USA: 'United States',
    PER: 'Peru',
  },
  no_diagnostics_found: 'No assessments found',
  loading_diagnostics: 'Loading assessments...',
  loading_questions: 'Loading questions...',
  no_questions_found: 'No questions found',
};
